function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var _Symbol$for;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import { Socket, Provider, RequestClient } from '@uppy/companion-client';
import EventTracker from '@uppy/utils/lib/EventTracker';
import emitSocketProgress from '@uppy/utils/lib/emitSocketProgress';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import { RateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import { createAbortError } from '@uppy/utils/lib/AbortController';
var packageJson = {
  "version": "3.1.2"
};
import MultipartUploader from './MultipartUploader.js';

function assertServerError(res) {
  if (res && res.error) {
    var error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }

  return res;
}

function throwIfAborted(signal) {
  if (signal != null && signal.aborted) {
    throw createAbortError('The operation was aborted', {
      cause: signal.reason
    });
  }
}

var _abortMultipartUpload = /*#__PURE__*/_classPrivateFieldLooseKey("abortMultipartUpload");

var _cache = /*#__PURE__*/_classPrivateFieldLooseKey("cache");

var _createMultipartUpload = /*#__PURE__*/_classPrivateFieldLooseKey("createMultipartUpload");

var _fetchSignature = /*#__PURE__*/_classPrivateFieldLooseKey("fetchSignature");

var _listParts = /*#__PURE__*/_classPrivateFieldLooseKey("listParts");

var _previousRetryDelay = /*#__PURE__*/_classPrivateFieldLooseKey("previousRetryDelay");

var _requests = /*#__PURE__*/_classPrivateFieldLooseKey("requests");

var _retryDelayIterator = /*#__PURE__*/_classPrivateFieldLooseKey("retryDelayIterator");

var _sendCompletionRequest = /*#__PURE__*/_classPrivateFieldLooseKey("sendCompletionRequest");

var _setS3MultipartState = /*#__PURE__*/_classPrivateFieldLooseKey("setS3MultipartState");

var _uploadPartBytes = /*#__PURE__*/_classPrivateFieldLooseKey("uploadPartBytes");

var _shouldRetry = /*#__PURE__*/_classPrivateFieldLooseKey("shouldRetry");

var HTTPCommunicationQueue = /*#__PURE__*/function () {
  function HTTPCommunicationQueue(_requests2, options, setS3MultipartState) {
    _classCallCheck(this, HTTPCommunicationQueue);

    Object.defineProperty(this, _shouldRetry, {
      value: _shouldRetry2
    });
    Object.defineProperty(this, _abortMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cache, {
      writable: true,
      value: new WeakMap()
    });
    Object.defineProperty(this, _createMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fetchSignature, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _listParts, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousRetryDelay, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _retryDelayIterator, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _sendCompletionRequest, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadPartBytes, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _requests)[_requests] = _requests2;
    _classPrivateFieldLooseBase(this, _setS3MultipartState)[_setS3MultipartState] = setS3MultipartState;
    this.setOptions(options);
  }

  _createClass(HTTPCommunicationQueue, [{
    key: "setOptions",
    value: function setOptions(options) {
      var requests = _classPrivateFieldLooseBase(this, _requests)[_requests];

      if ('abortMultipartUpload' in options) {
        _classPrivateFieldLooseBase(this, _abortMultipartUpload)[_abortMultipartUpload] = requests.wrapPromiseFunction(options.abortMultipartUpload);
      }

      if ('createMultipartUpload' in options) {
        _classPrivateFieldLooseBase(this, _createMultipartUpload)[_createMultipartUpload] = requests.wrapPromiseFunction(options.createMultipartUpload, {
          priority: -1
        });
      }

      if ('signPart' in options) {
        _classPrivateFieldLooseBase(this, _fetchSignature)[_fetchSignature] = requests.wrapPromiseFunction(options.signPart);
      }

      if ('listParts' in options) {
        _classPrivateFieldLooseBase(this, _listParts)[_listParts] = requests.wrapPromiseFunction(options.listParts);
      }

      if ('completeMultipartUpload' in options) {
        _classPrivateFieldLooseBase(this, _sendCompletionRequest)[_sendCompletionRequest] = requests.wrapPromiseFunction(options.completeMultipartUpload);
      }

      if ('retryDelays' in options) {
        var _options$retryDelays;

        _classPrivateFieldLooseBase(this, _retryDelayIterator)[_retryDelayIterator] = (_options$retryDelays = options.retryDelays) == null ? void 0 : _options$retryDelays.values();
      }

      if ('uploadPartBytes' in options) {
        _classPrivateFieldLooseBase(this, _uploadPartBytes)[_uploadPartBytes] = requests.wrapPromiseFunction(options.uploadPartBytes, {
          priority: Infinity
        });
      }
    }
  }, {
    key: "getUploadId",
    value: function () {
      var _getUploadId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, signal) {
        var _this4 = this;

        var cachedResult, promise, abortPromise;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cachedResult = _classPrivateFieldLooseBase(this, _cache)[_cache].get(file.data);

                if (!(cachedResult != null)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", cachedResult);

              case 3:
                promise = _classPrivateFieldLooseBase(this, _createMultipartUpload)[_createMultipartUpload](file, signal);

                abortPromise = function abortPromise() {
                  promise.abort(signal.reason);

                  _classPrivateFieldLooseBase(_this4, _cache)[_cache].delete(file.data);
                };

                signal.addEventListener('abort', abortPromise, {
                  once: true
                });

                _classPrivateFieldLooseBase(this, _cache)[_cache].set(file.data, promise);

                promise.then( /*#__PURE__*/function () {
                  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(result) {
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            signal.removeEventListener('abort', abortPromise);

                            _classPrivateFieldLooseBase(_this4, _setS3MultipartState)[_setS3MultipartState](file, result);

                            _classPrivateFieldLooseBase(_this4, _cache)[_cache].set(file.data, result);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref9.apply(this, arguments);
                  };
                }(), function () {
                  signal.removeEventListener('abort', abortPromise);
                });
                return _context2.abrupt("return", promise);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUploadId(_x, _x2) {
        return _getUploadId.apply(this, arguments);
      }

      return getUploadId;
    }()
  }, {
    key: "abortFileUpload",
    value: function () {
      var _abortFileUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                result = _classPrivateFieldLooseBase(this, _cache)[_cache].get(file.data);

                if (!(result != null)) {
                  _context3.next = 10;
                  break;
                }

                _context3.t0 = _classPrivateFieldLooseBase(this, _abortMultipartUpload);
                _context3.t1 = _abortMultipartUpload;
                _context3.t2 = file;
                _context3.next = 7;
                return result;

              case 7:
                _context3.t3 = _context3.sent;
                _context3.next = 10;
                return _context3.t0[_context3.t1].call(_context3.t0, _context3.t2, _context3.t3);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function abortFileUpload(_x4) {
        return _abortFileUpload.apply(this, arguments);
      }

      return abortFileUpload;
    }()
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file, chunks, signal) {
        var _this5 = this;

        var _yield$this$getUpload, uploadId, key, parts;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                throwIfAborted(signal);
                _context4.next = 3;
                return this.getUploadId(file, signal);

              case 3:
                _yield$this$getUpload = _context4.sent;
                uploadId = _yield$this$getUpload.uploadId;
                key = _yield$this$getUpload.key;
                throwIfAborted(signal);
                _context4.next = 9;
                return Promise.all(chunks.map(function (chunk, i) {
                  return _this5.uploadChunk(file, i + 1, chunk, signal);
                }));

              case 9:
                parts = _context4.sent;
                throwIfAborted(signal);
                return _context4.abrupt("return", _classPrivateFieldLooseBase(this, _sendCompletionRequest)[_sendCompletionRequest](file, {
                  key: key,
                  uploadId: uploadId,
                  parts: parts,
                  signal: signal
                }).abortOn(signal));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function uploadFile(_x5, _x6, _x7) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "resumeUploadFile",
    value: function () {
      var _resumeUploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(file, chunks, signal) {
        var _this6 = this;

        var _yield$this$getUpload2, uploadId, key, alreadyUploadedParts, parts;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                throwIfAborted(signal);
                _context5.next = 3;
                return this.getUploadId(file, signal);

              case 3:
                _yield$this$getUpload2 = _context5.sent;
                uploadId = _yield$this$getUpload2.uploadId;
                key = _yield$this$getUpload2.key;
                throwIfAborted(signal);
                _context5.next = 9;
                return _classPrivateFieldLooseBase(this, _listParts)[_listParts](file, {
                  uploadId: uploadId,
                  key: key,
                  signal: signal
                }).abortOn(signal);

              case 9:
                alreadyUploadedParts = _context5.sent;
                throwIfAborted(signal);
                _context5.next = 13;
                return Promise.all(chunks.map(function (chunk, i) {
                  var partNumber = i + 1;
                  var alreadyUploadedInfo = alreadyUploadedParts.find(function (_ref) {
                    var PartNumber = _ref.PartNumber;
                    return PartNumber === partNumber;
                  });
                  return alreadyUploadedInfo == null ? _this6.uploadChunk(file, partNumber, chunk, signal) : {
                    PartNumber: partNumber,
                    ETag: alreadyUploadedInfo.ETag
                  };
                }));

              case 13:
                parts = _context5.sent;
                throwIfAborted(signal);
                return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _sendCompletionRequest)[_sendCompletionRequest](file, {
                  key: key,
                  uploadId: uploadId,
                  parts: parts,
                  signal: signal
                }).abortOn(signal));

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function resumeUploadFile(_x8, _x9, _x10) {
        return _resumeUploadFile.apply(this, arguments);
      }

      return resumeUploadFile;
    }()
  }, {
    key: "uploadChunk",
    value: function () {
      var _uploadChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(file, partNumber, body, signal) {
        var _yield$this$getUpload3, uploadId, key, signature;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                throwIfAborted(signal);
                _context6.next = 3;
                return this.getUploadId(file, signal);

              case 3:
                _yield$this$getUpload3 = _context6.sent;
                uploadId = _yield$this$getUpload3.uploadId;
                key = _yield$this$getUpload3.key;
                throwIfAborted(signal);

              case 7:
                _context6.next = 9;
                return _classPrivateFieldLooseBase(this, _fetchSignature)[_fetchSignature](file, {
                  uploadId: uploadId,
                  key: key,
                  partNumber: partNumber,
                  body: body,
                  signal: signal
                }).abortOn(signal);

              case 9:
                signature = _context6.sent;
                throwIfAborted(signal);
                _context6.prev = 11;
                _context6.t0 = _objectSpread;
                _context6.t1 = {
                  PartNumber: partNumber
                };
                _context6.next = 16;
                return _classPrivateFieldLooseBase(this, _uploadPartBytes)[_uploadPartBytes](signature, body, signal).abortOn(signal);

              case 16:
                _context6.t2 = _context6.sent;
                return _context6.abrupt("return", (0, _context6.t0)(_context6.t1, _context6.t2));

              case 20:
                _context6.prev = 20;
                _context6.t3 = _context6["catch"](11);
                _context6.next = 24;
                return _classPrivateFieldLooseBase(this, _shouldRetry)[_shouldRetry](_context6.t3);

              case 24:
                if (_context6.sent) {
                  _context6.next = 26;
                  break;
                }

                throw _context6.t3;

              case 26:
                _context6.next = 7;
                break;

              case 28:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[11, 20]]);
      }));

      function uploadChunk(_x11, _x12, _x13, _x14) {
        return _uploadChunk.apply(this, arguments);
      }

      return uploadChunk;
    }()
  }]);

  return HTTPCommunicationQueue;
}();

function _shouldRetry2(_x15) {
  return _shouldRetry3.apply(this, arguments);
}

function _shouldRetry3() {
  _shouldRetry3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(err) {
    var _this14 = this;

    var _err$source, requests, status, _classPrivateFieldLoo, next, _classPrivateFieldLoo2, _next2, _classPrivateFieldLoo3, _next3;

    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            requests = _classPrivateFieldLooseBase(this, _requests)[_requests];
            status = err == null ? void 0 : (_err$source = err.source) == null ? void 0 : _err$source.status; // TODO: this retry logic is taken out of Tus. We should have a centralized place for retrying,
            // perhaps the rate limited queue, and dedupe all plugins with that.

            if (!(status == null)) {
              _context13.next = 4;
              break;
            }

            return _context13.abrupt("return", false);

          case 4:
            if (!(status === 403 && err.message === 'Request has expired')) {
              _context13.next = 16;
              break;
            }

            if (requests.isPaused) {
              _context13.next = 14;
              break;
            }

            if (!(requests.limit === 1 || _classPrivateFieldLooseBase(this, _previousRetryDelay)[_previousRetryDelay] == null)) {
              _context13.next = 11;
              break;
            }

            next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo.next();

            if (!(next == null || next.done)) {
              _context13.next = 10;
              break;
            }

            return _context13.abrupt("return", false);

          case 10:
            // If there are more than 1 request done in parallel, the RLQ limit is
            // decreased and the failed request is requeued after waiting for a bit.
            // If there is only one request in parallel, the limit can't be
            // decreased, so we iterate over `retryDelayIterator` as we do for
            // other failures.
            // `#previousRetryDelay` caches the value so we can re-use it next time.
            _classPrivateFieldLooseBase(this, _previousRetryDelay)[_previousRetryDelay] = next.value;

          case 11:
            // No need to stop the other requests, we just want to lower the limit.
            requests.rateLimit(0);
            _context13.next = 14;
            return new Promise(function (resolve) {
              return setTimeout(resolve, _classPrivateFieldLooseBase(_this14, _previousRetryDelay)[_previousRetryDelay]);
            });

          case 14:
            _context13.next = 37;
            break;

          case 16:
            if (!(status === 429)) {
              _context13.next = 24;
              break;
            }

            if (requests.isPaused) {
              _context13.next = 22;
              break;
            }

            _next2 = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo2.next();

            if (!(_next2 == null || _next2.done)) {
              _context13.next = 21;
              break;
            }

            return _context13.abrupt("return", false);

          case 21:
            requests.rateLimit(_next2.value);

          case 22:
            _context13.next = 37;
            break;

          case 24:
            if (!(status > 400 && status < 500 && status !== 409)) {
              _context13.next = 28;
              break;
            }

            return _context13.abrupt("return", false);

          case 28:
            if (!(typeof navigator !== 'undefined' && navigator.onLine === false)) {
              _context13.next = 32;
              break;
            }

            // The navigator is offline, let's wait for it to come back online.
            if (!requests.isPaused) {
              requests.pause();
              window.addEventListener('online', function () {
                requests.resume();
              }, {
                once: true
              });
            }

            _context13.next = 37;
            break;

          case 32:
            // Other error code means the request can be retried later.
            _next3 = (_classPrivateFieldLoo3 = _classPrivateFieldLooseBase(this, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo3.next();

            if (!(_next3 == null || _next3.done)) {
              _context13.next = 35;
              break;
            }

            return _context13.abrupt("return", false);

          case 35:
            _context13.next = 37;
            return new Promise(function (resolve) {
              return setTimeout(resolve, _next3.value);
            });

          case 37:
            return _context13.abrupt("return", true);

          case 38:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));
  return _shouldRetry3.apply(this, arguments);
}

var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");

var _companionCommunicationQueue = /*#__PURE__*/_classPrivateFieldLooseKey("companionCommunicationQueue");

var _client = /*#__PURE__*/_classPrivateFieldLooseKey("client");

var _setS3MultipartState2 = /*#__PURE__*/_classPrivateFieldLooseKey("setS3MultipartState");

var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");

var _setCompanionHeaders = /*#__PURE__*/_classPrivateFieldLooseKey("setCompanionHeaders");

_Symbol$for = Symbol.for('uppy test: getClient');

var AwsS3Multipart = /*#__PURE__*/function (_BasePlugin, _Symbol$for2) {
  _inherits(AwsS3Multipart, _BasePlugin);

  var _super = _createSuper(AwsS3Multipart);

  function AwsS3Multipart(uppy, _opts) {
    var _this7;

    _classCallCheck(this, AwsS3Multipart);

    var _this$opts$rateLimite;

    _this7 = _super.call(this, uppy, _opts);
    Object.defineProperty(_assertThisInitialized(_this7), _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this7), _companionCommunicationQueue, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this7), _client, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this7), _setS3MultipartState2, {
      writable: true,
      value: function value(file, _ref2) {
        var key = _ref2.key,
            uploadId = _ref2.uploadId;

        var cFile = _this7.uppy.getFile(file.id);

        _this7.uppy.setFileState(file.id, {
          s3Multipart: _objectSpread(_objectSpread({}, cFile.s3Multipart), {}, {
            key: key,
            uploadId: uploadId
          })
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this7), _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(file) {
          var Client, client, opts, res;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  Client = file.remote.providerOptions.provider ? Provider : RequestClient;
                  client = new Client(_this7.uppy, file.remote.providerOptions);
                  opts = _objectSpread({}, _this7.opts);

                  if (file.tus) {
                    // Install file-specific upload overrides.
                    Object.assign(opts, file.tus);
                  }

                  if (!(file.remote.url == null)) {
                    _context7.next = 6;
                    break;
                  }

                  throw new Error('Cannot connect to an undefined URL');

                case 6:
                  _context7.next = 8;
                  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                    protocol: 's3-multipart',
                    size: file.data.size,
                    metadata: file.meta
                  }));

                case 8:
                  res = _context7.sent;
                  return _context7.abrupt("return", res.token);

                case 10:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        function value(_x16) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this7), _setCompanionHeaders, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this7), _client)[_client].setCompanionHeaders(_this7.opts.companionHeaders);
      }
    });
    _this7.type = 'uploader';
    _this7.id = _this7.opts.id || 'AwsS3Multipart';
    _this7.title = 'AWS S3 Multipart';
    _classPrivateFieldLooseBase(_assertThisInitialized(_this7), _client)[_client] = new RequestClient(uppy, _opts);
    var defaultOptions = {
      // TODO: this is currently opt-in for backward compat, switch to opt-out in the next major
      allowedMetaFields: null,
      limit: 6,
      retryDelays: [0, 1000, 3000, 5000],
      createMultipartUpload: _this7.createMultipartUpload.bind(_assertThisInitialized(_this7)),
      listParts: _this7.listParts.bind(_assertThisInitialized(_this7)),
      abortMultipartUpload: _this7.abortMultipartUpload.bind(_assertThisInitialized(_this7)),
      completeMultipartUpload: _this7.completeMultipartUpload.bind(_assertThisInitialized(_this7)),
      signPart: _this7.signPart.bind(_assertThisInitialized(_this7)),
      uploadPartBytes: AwsS3Multipart.uploadPartBytes,
      companionHeaders: {}
    };
    _this7.opts = _objectSpread(_objectSpread({}, defaultOptions), _opts);

    if ((_opts == null ? void 0 : _opts.prepareUploadParts) != null && _opts.signPart == null) {
      _this7.opts.signPart = /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(file, _ref3) {
          var uploadId, key, partNumber, body, signal, _yield$_opts$prepareU, presignedUrls, headers;

          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  uploadId = _ref3.uploadId, key = _ref3.key, partNumber = _ref3.partNumber, body = _ref3.body, signal = _ref3.signal;
                  _context8.next = 3;
                  return _opts.prepareUploadParts(file, {
                    uploadId: uploadId,
                    key: key,
                    parts: [{
                      number: partNumber,
                      chunk: body
                    }],
                    signal: signal
                  });

                case 3:
                  _yield$_opts$prepareU = _context8.sent;
                  presignedUrls = _yield$_opts$prepareU.presignedUrls;
                  headers = _yield$_opts$prepareU.headers;
                  return _context8.abrupt("return", {
                    url: presignedUrls == null ? void 0 : presignedUrls[partNumber],
                    headers: headers == null ? void 0 : headers[partNumber]
                  });

                case 7:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x17, _x18) {
          return _ref10.apply(this, arguments);
        };
      }();
    }

    _this7.upload = _this7.upload.bind(_assertThisInitialized(_this7));
    /**
     * Simultaneous upload limiting is shared across all uploads with this plugin.
     *
     * @type {RateLimitedQueue}
     */

    _this7.requests = (_this$opts$rateLimite = _this7.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue(_this7.opts.limit);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this7), _companionCommunicationQueue)[_companionCommunicationQueue] = new HTTPCommunicationQueue(_this7.requests, _this7.opts, _classPrivateFieldLooseBase(_assertThisInitialized(_this7), _setS3MultipartState2)[_setS3MultipartState2]);
    _this7.uploaders = Object.create(null);
    _this7.uploaderEvents = Object.create(null);
    _this7.uploaderSockets = Object.create(null);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this7), _queueRequestSocketToken)[_queueRequestSocketToken] = _this7.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(_assertThisInitialized(_this7), _requestSocketToken)[_requestSocketToken], {
      priority: -1
    });
    return _this7;
  }

  _createClass(AwsS3Multipart, [{
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _client)[_client];
    }
  }, {
    key: "setOptions",
    value: function setOptions(newOptions) {
      _classPrivateFieldLooseBase(this, _companionCommunicationQueue)[_companionCommunicationQueue].setOptions(newOptions);

      return _get(_getPrototypeOf(AwsS3Multipart.prototype), "setOptions", this).call(this, newOptions);
    }
    /**
     * Clean up all references for a file's upload: the MultipartUploader instance,
     * any events related to the file, and the Companion WebSocket connection.
     *
     * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
     * This should be done when the user cancels the upload, not when the upload is completed or errored.
     */

  }, {
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      if (opts === void 0) {
        opts = {};
      }

      if (this.uploaders[fileID]) {
        this.uploaders[fileID].abort({
          really: opts.abort || false
        });
        this.uploaders[fileID] = null;
      }

      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }

      if (this.uploaderSockets[fileID]) {
        this.uploaderSockets[fileID].close();
        this.uploaderSockets[fileID] = null;
      }
    } // TODO: make this a private method in the next major

  }, {
    key: "assertHost",
    value: function assertHost(method) {
      if (!this.opts.companionUrl) {
        throw new Error("Expected a `companionUrl` option containing a Companion address, or if you are not using Companion, a custom `".concat(method, "` implementation."));
      }
    }
  }, {
    key: "createMultipartUpload",
    value: function createMultipartUpload(file, signal) {
      var _this$opts$allowedMet;

      this.assertHost('createMultipartUpload');
      throwIfAborted(signal);
      var metadata = file.meta ? Object.fromEntries(((_this$opts$allowedMet = this.opts.allowedMetaFields) != null ? _this$opts$allowedMet : Object.keys(file.meta)).filter(function (key) {
        return file.meta[key] != null;
      }).map(function (key) {
        return [key, String(file.meta[key])];
      })) : {};
      return _classPrivateFieldLooseBase(this, _client)[_client].post('s3/multipart', {
        filename: file.name,
        type: file.type,
        metadata: metadata
      }, {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "listParts",
    value: function listParts(file, _ref4, signal) {
      var key = _ref4.key,
          uploadId = _ref4.uploadId;
      this.assertHost('listParts');
      throwIfAborted(signal);
      var filename = encodeURIComponent(key);
      return _classPrivateFieldLooseBase(this, _client)[_client].get("s3/multipart/".concat(uploadId, "?key=").concat(filename), {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "completeMultipartUpload",
    value: function completeMultipartUpload(file, _ref5, signal) {
      var key = _ref5.key,
          uploadId = _ref5.uploadId,
          parts = _ref5.parts;
      this.assertHost('completeMultipartUpload');
      throwIfAborted(signal);
      var filename = encodeURIComponent(key);
      var uploadIdEnc = encodeURIComponent(uploadId);
      return _classPrivateFieldLooseBase(this, _client)[_client].post("s3/multipart/".concat(uploadIdEnc, "/complete?key=").concat(filename), {
        parts: parts
      }, {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "signPart",
    value: function signPart(file, _ref6) {
      var uploadId = _ref6.uploadId,
          key = _ref6.key,
          partNumber = _ref6.partNumber,
          signal = _ref6.signal;
      this.assertHost('signPart');
      throwIfAborted(signal);

      if (uploadId == null || key == null || partNumber == null) {
        throw new Error('Cannot sign without a key, an uploadId, and a partNumber');
      }

      var filename = encodeURIComponent(key);
      return _classPrivateFieldLooseBase(this, _client)[_client].get("s3/multipart/".concat(uploadId, "/").concat(partNumber, "?key=").concat(filename), {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "abortMultipartUpload",
    value: function abortMultipartUpload(file, _ref7, signal) {
      var key = _ref7.key,
          uploadId = _ref7.uploadId;
      this.assertHost('abortMultipartUpload');
      var filename = encodeURIComponent(key);
      var uploadIdEnc = encodeURIComponent(uploadId);
      return _classPrivateFieldLooseBase(this, _client)[_client].delete("s3/multipart/".concat(uploadIdEnc, "?key=").concat(filename), undefined, {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      var _this8 = this;

      var _this = this;

      return new Promise(function (resolve, reject) {
        var onProgress = function onProgress(bytesUploaded, bytesTotal) {
          _this8.uppy.emit('upload-progress', file, {
            uploader: _this8,
            bytesUploaded: bytesUploaded,
            bytesTotal: bytesTotal
          });
        };

        var onError = function onError(err) {
          _this8.uppy.log(err);

          _this8.uppy.emit('upload-error', file, err);

          _this8.resetUploaderReferences(file.id);

          reject(err);
        };

        var onSuccess = function onSuccess(result) {
          var uploadObject = upload; // eslint-disable-line no-use-before-define

          var uploadResp = {
            body: _objectSpread({}, result),
            uploadURL: result.location
          };

          _this8.resetUploaderReferences(file.id);

          var cFile = _this8.uppy.getFile(file.id);

          _this8.uppy.emit('upload-success', cFile || file, uploadResp);

          if (result.location) {
            _this8.uppy.log("Download ".concat(file.name, " from ").concat(result.location));
          }

          resolve(uploadObject);
        };

        var onPartComplete = function onPartComplete(part) {
          var cFile = _this8.uppy.getFile(file.id);

          if (!cFile) {
            return;
          }

          _this8.uppy.emit('s3-multipart:part-uploaded', cFile, part);
        };

        var upload = new MultipartUploader(file.data, _objectSpread({
          // .bind to pass the file object to each handler.
          companionComm: _classPrivateFieldLooseBase(_this8, _companionCommunicationQueue)[_companionCommunicationQueue],
          log: function log() {
            var _this$uppy;

            return (_this$uppy = _this.uppy).log.apply(_this$uppy, arguments);
          },
          getChunkSize: _this8.opts.getChunkSize ? _this8.opts.getChunkSize.bind(_this8) : null,
          onProgress: onProgress,
          onError: onError,
          onSuccess: onSuccess,
          onPartComplete: onPartComplete,
          file: file
        }, file.s3Multipart));
        _this8.uploaders[file.id] = upload;
        _this8.uploaderEvents[file.id] = new EventTracker(_this8.uppy);

        _this8.onFileRemove(file.id, function (removed) {
          upload.abort();

          _this8.resetUploaderReferences(file.id, {
            abort: true
          });

          resolve("upload ".concat(removed.id, " was removed"));
        });

        _this8.onCancelAll(file.id, function (_temp) {
          var _ref11 = _temp === void 0 ? {} : _temp,
              reason = _ref11.reason;

          if (reason === 'user') {
            upload.abort();

            _this.resetUploaderReferences(file.id, {
              abort: true
            });
          }

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this8.onFilePause(file.id, function (isPaused) {
          if (isPaused) {
            upload.pause();
          } else {
            upload.start();
          }
        });

        _this8.onPauseAll(file.id, function () {
          upload.pause();
        });

        _this8.onResumeAll(file.id, function () {
          upload.start();
        }); // Don't double-emit upload-started for Golden Retriever-restored files that were already started


        if (!file.progress.uploadStarted || !file.isRestored) {
          upload.start();

          _this8.uppy.emit('upload-started', file);
        }
      });
    }
  }, {
    key: "uploadRemote",
    value: function () {
      var _uploadRemote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(file) {
        var serverToken;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.resetUploaderReferences(file.id); // Don't double-emit upload-started for Golden Retriever-restored files that were already started

                if (!file.progress.uploadStarted || !file.isRestored) {
                  this.uppy.emit('upload-started', file);
                }

                _context9.prev = 2;

                if (!file.serverToken) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", this.connectToServerSocket(file));

              case 5:
                _context9.next = 7;
                return _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken](file);

              case 7:
                serverToken = _context9.sent;
                this.uppy.setFileState(file.id, {
                  serverToken: serverToken
                });
                return _context9.abrupt("return", this.connectToServerSocket(this.uppy.getFile(file.id)));

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](2);
                this.uppy.emit('upload-error', file, _context9.t0);
                throw _context9.t0;

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 12]]);
      }));

      function uploadRemote(_x19) {
        return _uploadRemote.apply(this, arguments);
      }

      return uploadRemote;
    }()
  }, {
    key: "connectToServerSocket",
    value: function () {
      var _connectToServerSocket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(file) {
        var _this9 = this;

        var _this2;

        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this2 = this;
                return _context10.abrupt("return", new Promise(function (resolve, reject) {
                  var queuedRequest;
                  var token = file.serverToken;
                  var host = getSocketHost(file.remote.companionUrl);
                  var socket = new Socket({
                    target: "".concat(host, "/api/").concat(token)
                  });
                  _this9.uploaderSockets[file.id] = socket;
                  _this9.uploaderEvents[file.id] = new EventTracker(_this9.uppy);

                  _this9.onFileRemove(file.id, function () {
                    queuedRequest.abort();
                    socket.send('cancel', {});

                    _this9.resetUploaderReferences(file.id, {
                      abort: true
                    });

                    resolve("upload ".concat(file.id, " was removed"));
                  });

                  _this9.onFilePause(file.id, function (isPaused) {
                    if (isPaused) {
                      // Remove this file from the queue so another file can start in its place.
                      queuedRequest.abort();
                      socket.send('pause', {});
                    } else {
                      // Resuming an upload should be queued, else you could pause and then
                      // resume a queued upload to make it skip the queue.
                      queuedRequest.abort();
                      queuedRequest = _this9.requests.run(function () {
                        socket.send('resume', {});
                        return function () {};
                      });
                    }
                  });

                  _this9.onPauseAll(file.id, function () {
                    queuedRequest.abort();
                    socket.send('pause', {});
                  });

                  _this9.onCancelAll(file.id, function (_temp2) {
                    var _ref12 = _temp2 === void 0 ? {} : _temp2,
                        reason = _ref12.reason;

                    if (reason === 'user') {
                      queuedRequest.abort();
                      socket.send('cancel', {});

                      _this2.resetUploaderReferences(file.id);
                    }

                    resolve("upload ".concat(file.id, " was canceled"));
                  });

                  _this9.onResumeAll(file.id, function () {
                    queuedRequest.abort();

                    if (file.error) {
                      socket.send('pause', {});
                    }

                    queuedRequest = _this9.requests.run(function () {
                      socket.send('resume', {});
                    });
                  });

                  _this9.onRetry(file.id, function () {
                    // Only do the retry if the upload is actually in progress;
                    // else we could try to send these messages when the upload is still queued.
                    // We may need a better check for this since the socket may also be closed
                    // for other reasons, like network failures.
                    if (socket.isOpen) {
                      socket.send('pause', {});
                      socket.send('resume', {});
                    }
                  });

                  _this9.onRetryAll(file.id, function () {
                    if (socket.isOpen) {
                      socket.send('pause', {});
                      socket.send('resume', {});
                    }
                  });

                  socket.on('progress', function (progressData) {
                    return emitSocketProgress(_this9, progressData, file);
                  });
                  socket.on('error', function (errData) {
                    _this9.uppy.emit('upload-error', file, new Error(errData.error));

                    _this9.resetUploaderReferences(file.id);

                    queuedRequest.done();
                    reject(new Error(errData.error));
                  });
                  socket.on('success', function (data) {
                    var uploadResp = {
                      uploadURL: data.url
                    };

                    _this9.uppy.emit('upload-success', file, uploadResp);

                    _this9.resetUploaderReferences(file.id);

                    queuedRequest.done();
                    resolve();
                  });
                  queuedRequest = _this9.requests.run(function () {
                    if (file.isPaused) {
                      socket.send('pause', {});
                    }

                    return function () {};
                  });
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function connectToServerSocket(_x20) {
        return _connectToServerSocket.apply(this, arguments);
      }

      return connectToServerSocket;
    }()
  }, {
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(fileIDs) {
        var _this10 = this;

        var promises;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(fileIDs.length === 0)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return", undefined);

              case 2:
                promises = fileIDs.map(function (id) {
                  var file = _this10.uppy.getFile(id);

                  if (file.isRemote) {
                    return _this10.uploadRemote(file);
                  }

                  return _this10.uploadFile(file);
                });
                return _context11.abrupt("return", Promise.all(promises));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function upload(_x21) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
  }, {
    key: "onFilePause",
    value: function onFilePause(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-pause', function (targetFileID, isPaused) {
        if (fileID === targetFileID) {
          cb(isPaused);
        }
      });
    }
  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this11 = this;

      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this11.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onPauseAll",
    value: function onPauseAll(fileID, cb) {
      var _this12 = this;

      this.uploaderEvents[fileID].on('pause-all', function () {
        if (!_this12.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, eventHandler) {
      var _this3 = this;

      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this3.uppy.getFile(fileID)) return;
        eventHandler.apply(void 0, arguments);
      });
    }
  }, {
    key: "onResumeAll",
    value: function onResumeAll(fileID, cb) {
      var _this13 = this;

      this.uploaderEvents[fileID].on('resume-all', function () {
        if (!_this13.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "install",
    value: function install() {
      var _this$uppy$getState = this.uppy.getState(),
          capabilities = _this$uppy$getState.capabilities;

      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          resumableUploads: true
        })
      });
      this.uppy.addPreProcessor(_classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]);
      this.uppy.addUploader(this.upload);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      var _this$uppy$getState2 = this.uppy.getState(),
          capabilities = _this$uppy$getState2.capabilities;

      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          resumableUploads: false
        })
      });
      this.uppy.removePreProcessor(_classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]);
      this.uppy.removeUploader(this.upload);
    }
  }], [{
    key: "uploadPartBytes",
    value: function () {
      var _uploadPartBytes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref8, body, signal) {
        var url, expires, headers;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                url = _ref8.url, expires = _ref8.expires, headers = _ref8.headers;
                throwIfAborted(signal);

                if (!(url == null)) {
                  _context12.next = 4;
                  break;
                }

                throw new Error('Cannot upload to an undefined URL');

              case 4:
                return _context12.abrupt("return", new Promise(function (resolve, reject) {
                  var xhr = new XMLHttpRequest();
                  xhr.open('PUT', url, true);

                  if (headers) {
                    Object.keys(headers).forEach(function (key) {
                      xhr.setRequestHeader(key, headers[key]);
                    });
                  }

                  xhr.responseType = 'text';

                  if (typeof expires === 'number') {
                    xhr.timeout = expires * 1000;
                  }

                  function onabort() {
                    xhr.abort();
                  }

                  function cleanup() {
                    signal.removeEventListener('abort', onabort);
                  }

                  signal.addEventListener('abort', onabort);
                  xhr.upload.addEventListener('progress', body.onProgress);
                  xhr.addEventListener('abort', function () {
                    cleanup();
                    reject(createAbortError());
                  });
                  xhr.addEventListener('timeout', function () {
                    cleanup();
                    var error = new Error('Request has expired');
                    error.source = {
                      status: 403
                    };
                    reject(error);
                  });
                  xhr.addEventListener('load', function (ev) {
                    cleanup();

                    if (ev.target.status === 403 && ev.target.responseText.includes('<Message>Request has expired</Message>')) {
                      var error = new Error('Request has expired');
                      error.source = ev.target;
                      reject(error);
                      return;
                    }

                    if (ev.target.status < 200 || ev.target.status >= 300) {
                      var _error = new Error('Non 2xx');

                      _error.source = ev.target;
                      reject(_error);
                      return;
                    }

                    body.onProgress == null ? void 0 : body.onProgress(body.size); // NOTE This must be allowed by CORS.

                    var etag = ev.target.getResponseHeader('ETag');

                    if (etag === null) {
                      reject(new Error('AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.'));
                      return;
                    }

                    body.onComplete == null ? void 0 : body.onComplete(etag);
                    resolve({
                      ETag: etag
                    });
                  });
                  xhr.addEventListener('error', function (ev) {
                    cleanup();
                    var error = new Error('Unknown error');
                    error.source = ev.target;
                    reject(error);
                  });
                  xhr.send(body);
                }));

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function uploadPartBytes(_x22, _x23, _x24) {
        return _uploadPartBytes2.apply(this, arguments);
      }

      return uploadPartBytes;
    }()
  }]);

  return AwsS3Multipart;
}(BasePlugin, _Symbol$for);

export { AwsS3Multipart as default };
AwsS3Multipart.VERSION = packageJson.version;